import { FC, PropsWithChildren, createElement } from 'react'

import { classNames } from '@common/utils/helpers'

interface ICardHeaderTitle {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h6'
  className?: string
}

/**
 * @deprecated use {@palqee/ui/card}
 */
const CardHeaderTitle: FC<PropsWithChildren<ICardHeaderTitle>> = (props) => {
  const { children, as, className, ...rest } = props

  const classes = classNames('pq-card__header__title', className)

  return createElement(
    as,
    {
      className: classes,
      ...rest,
    },
    children,
  )
}

export { CardHeaderTitle }
